import { apiHelper } from './api_helper';

export const namHocAPi = {
    SelectAll: () => apiHelper.get('nam-hoc')
}